import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, addClass, removeClass } from '@fretadao/f-js-dom';

application.register('bus-operator-admin-documents-toggle-required', class extends Controller {
  connect() {
    const fileField = find('input[type=file]', this.element);
    const expirationField = find('input[type=date]', this.element);

    if (!fileField || !expirationField) return;

    fileField.addEventListener('change', (e) => { this.#toggleRequired(e.target, expirationField) });
    expirationField.addEventListener('change', (e) => { this.#toggleRequired(e.target, fileField) });
  }

  #toggleRequired(field, dependentField) {
    const requiredLabelClass = 'Form-label--symbol-required';
    const required = !!field.value;
    const labelElem = find('label.expiration_in', this.element);

    dependentField.required = required;

    if (!labelElem) return;

    required ? addClass(labelElem, requiredLabelClass) : removeClass(labelElem, requiredLabelClass);
  }
});
